export default __webpack_public_path__ + "static/media/img-04-mini.78c53e65.png";